<template>
  <v-flex class="statsAdmin pa-4">
    <v-toolbar flat class="mx-auto mb-4">
      <v-btn icon v-on:click.native="goBack()" >
          <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title class="headline">{{msg}}</v-toolbar-title>
    </v-toolbar>
    <voice-data-table-stats-admin  class="mb-4" v-if="userGroup === 'ampsVoiceTrackerAdmin'"></voice-data-table-stats-admin> 
    <v-layout column align-center v-else>
      <div>
        You don't have permission to access that page.
        <router-link to="/">Click here</router-link>
          to return to the homepage.
      </div>
    </v-layout>
  </v-flex>
</template>

<script>
import DataTableStatsAdmin from './stats/DataTableStatsAdmin.vue'

export default {
  data () {
    return {
      msg: 'Admin Stats',
      userGroup: localStorage.userGroup,
    }
  },
  components: {
            'voice-data-table-stats-admin': DataTableStatsAdmin,
  },
  methods: {
    goBack(){ this.$router.back(); }
  },
}
</script>


<style scoped>
.statsAdmin{
    max-width: 100% !important;
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/StatsAdmin.vue